var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.53465 49.9868C3.53465 24.2536 24.3984 3.50311 50.0183 3.50311C75.6383 3.50311 96.502 24.2382 96.502 49.9868C96.502 60.91 92.7323 70.9551 86.4204 78.8869C77.7112 89.8716 64.4156 96.4714 50.0174 96.4714C35.6191 96.4714 22.3062 89.8303 13.6076 78.8869C7.29569 70.956 3.53369 60.9109 3.53369 49.9868H3.53465Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.93112 86.7486C9.43784 85.6305 8.92632 84.3071 7.80828 83.8004C6.69024 83.2937 5.37354 83.7898 4.86682 84.9079C4.36011 86.0259 4.84955 87.358 5.96759 87.8637C7.08563 88.3704 8.4244 87.8656 8.93112 86.7476V86.7486Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2162 91.1212C12.5386 90.4101 12.2133 89.5675 11.5021 89.245C10.791 88.9226 9.95224 89.2383 9.62978 89.9504C9.30732 90.6615 9.61922 91.5099 10.3304 91.8324C11.0415 92.1548 11.8937 91.8333 12.2162 91.1222V91.1212Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M91.1229 9.43035C91.9224 8.49945 91.8034 7.08486 90.8724 6.28544C89.9415 5.48601 88.5385 5.59254 87.7391 6.52344C86.9396 7.45434 87.0356 8.86989 87.9665 9.67027C88.8974 10.4697 90.3245 10.3612 91.1239 9.43035H91.1229Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.0498 14.5497C93.5585 13.9566 93.4826 13.0574 92.8905 12.5478C92.2974 12.0392 91.4049 12.1073 90.8963 12.6994C90.3876 13.2925 90.4481 14.1927 91.0412 14.7023C91.6343 15.2109 92.5422 15.1419 93.0508 14.5497H93.0498Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.7352 13.8375C12.5347 12.9066 12.4157 11.492 11.4848 10.6926C10.5539 9.89313 9.15078 9.99966 8.35136 10.9306C7.55193 11.8615 7.6479 13.277 8.5788 14.0774C9.50971 14.8768 10.9368 14.7684 11.7362 13.8375H11.7352Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M86.1853 26.5271V89.5193C86.1853 93.362 83.0768 96.4704 79.2342 96.4704H22.0663C18.2237 96.4704 15.1152 93.362 15.1152 89.5193V10.4542C15.1152 6.61156 18.2237 3.50311 22.0663 3.50311H61.7237C62.0864 3.50311 62.4425 3.5319 62.7908 3.58277C64.1344 3.79294 65.3983 4.39659 66.4146 5.33325L83.9329 21.4062C84.9789 22.3649 85.6977 23.6144 86.0029 24.9724C86.1267 25.481 86.1843 25.9964 86.1843 26.5271H86.1853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M86.0031 24.9726H66.1557C64.2977 24.9726 62.791 23.4659 62.791 21.6079V3.58299C64.1346 3.79317 65.3985 4.39681 66.4148 5.33347L83.933 21.4064C84.9791 22.3651 85.6979 23.6146 86.0031 24.9726Z",
    fill: "url(#paint0_linear_27_1031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.4328 11.082H27.9683C27.8236 11.082 27.7063 11.1993 27.7063 11.344V13.8805C27.7063 14.0252 27.8236 14.1425 27.9683 14.1425H52.4328C52.5775 14.1425 52.6948 14.0252 52.6948 13.8805V11.344C52.6948 11.1993 52.5775 11.082 52.4328 11.082Z",
    fill: "#E0E4ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M42.4263 18.3376H27.9685C27.8238 18.3376 27.7065 18.4549 27.7065 18.5996V21.136C27.7065 21.2807 27.8238 21.398 27.9685 21.398H42.4263C42.571 21.398 42.6883 21.2807 42.6883 21.136V18.5996C42.6883 18.4549 42.571 18.3376 42.4263 18.3376Z",
    fill: "#E0E4ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2305 34.0002H28.7695C28.3445 34.0002 28 34.1152 28 34.257V36.7434C28 36.8852 28.3445 37.0002 28.7695 37.0002H71.2305C71.6555 37.0002 72 36.8852 72 36.7434V34.257C72 34.1152 71.6555 34.0002 71.2305 34.0002Z",
    fill: "#E0E4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2305 34.0002H28.7695C28.3445 34.0002 28 34.1152 28 34.257V36.7434C28 36.8852 28.3445 37.0002 28.7695 37.0002H71.2305C71.6555 37.0002 72 36.8852 72 36.7434V34.257C72 34.1152 71.6555 34.0002 71.2305 34.0002Z",
    fill: "url(#paint1_linear_27_1031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5628 41.0002H28.4372C28.1957 41.0002 28 41.1152 28 41.257V43.7434C28 43.8852 28.1957 44.0002 28.4372 44.0002H52.5628C52.8043 44.0002 53 43.8852 53 43.7434V41.257C53 41.1152 52.8043 41.0002 52.5628 41.0002Z",
    fill: "#E0E4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5628 41.0002H28.4372C28.1957 41.0002 28 41.1152 28 41.257V43.7434C28 43.8852 28.1957 44.0002 28.4372 44.0002H52.5628C52.8043 44.0002 53 43.8852 53 43.7434V41.257C53 41.1152 52.8043 41.0002 52.5628 41.0002Z",
    fill: "url(#paint2_linear_27_1031)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1031",
    x1: 62.791,
    y1: 14.2778,
    x2: 86.0031,
    y2: 14.2778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_1031",
    x1: 31.08,
    y1: 34.3902,
    x2: 31.4418,
    y2: 39.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D24CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_1031",
    x1: 29.75,
    y1: 41.3902,
    x2: 30.3797,
    y2: 46.2719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D24CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.fc883334ca9a6aefc493d797ee630307.svg";
export { ForwardRef as ReactComponent };